module.exports = "/static/assets/227598e595f11ea77afb97fdc79b769c.gif";